import axios from 'axios';

const CLASSES = {
  promoApply: 'is-success',
  promoFail: 'is-error',
  promoLoad: 'is-loader',
};

const promoSuccessCallback = (e) => {
  e.preventDefault();
  const $target = e.currentTarget;
  const $input = $target.getElementsByTagName('input')[0];

  // Запрос
  axios.post($target.action, {
    data: {
      promo: $input.value,
    },
  }).then(() => {
    setPromoStatus($target, 'good');
  }).catch(() => {
    setPromoStatus($target, 'bad');
  });
};

const promoErrorCallback = (e) => {
  e.preventDefault();
  unsetLoadPromo(e.currentTarget);
};

const promoResetCallback = (form) => {
  const parent = getValidatorParent(form);
  parent.classList.remove(CLASSES.promoApply);
};

const setLoadPromo = (target) => {
  const parent = getValidatorParent(target);
  const btn = parent.querySelector('[type="submit"]');

  parent.classList.add(CLASSES.promoLoad);
  btn.classList.add(CLASSES.promoLoad);
};

const unsetLoadPromo = (target) => {
  const parent = getValidatorParent(target);
  const btn = parent.querySelector('[type="submit"]');

  btn.classList.remove(CLASSES.promoLoad);
  parent.classList.remove(CLASSES.promoLoad);
};

const setPromoStatus = (target, status) => {
  const parent = getValidatorParent(target);
  const input = parent.getElementsByTagName('INPUT')[0];

  unsetLoadPromo(target);

  switch (status) {
    case 'good':
      parent.classList.add(CLASSES.promoApply);
      break;
    case 'bad':
      input.addEventListener('focus', () => {
        parent.classList.remove(CLASSES.promoFail);
      }, {once: true});
      parent.classList.add(CLASSES.promoFail);
      break;
  }
};

const promoStartCallback = (e) => setLoadPromo(e.currentTarget);
const getValidatorParent = (el) => el.closest('[data-validate]');

export {promoStartCallback, promoSuccessCallback, promoErrorCallback, promoResetCallback};
